import { isEqual } from 'bold-ui'
import { ExameRealizadoPreNatalConsolidadoStatusEnum } from 'graphql/types.generated'
import { isEmpty } from 'util/validation/Util'

import {
  AcompanhamentoCondicaoSaudeFormModel,
  filterDefaultAcompanhamentoCondicaoSaude,
} from './model/model-acompanhamentoCondicaoSaude'

const statusToText: Record<ExameRealizadoPreNatalConsolidadoStatusEnum, string> = {
  [ExameRealizadoPreNatalConsolidadoStatusEnum.SIM]: 'Sim',
  [ExameRealizadoPreNatalConsolidadoStatusEnum.NAO]: 'Não',
  [ExameRealizadoPreNatalConsolidadoStatusEnum.NAO_SE_APLICA]: 'Não se aplica',
}

const statusInvalidoText = '-'

export const labelByStatus = (status?: ExameRealizadoPreNatalConsolidadoStatusEnum): string =>
  status ? statusToText[status] : statusInvalidoText

export function isFilterEqualDefault(filter: AcompanhamentoCondicaoSaudeFormModel) {
  const filterDefault = filterDefaultAcompanhamentoCondicaoSaude[filter.listaTematica]
  return isEqual(
    {
      periodoUltimoAtendimento: filter?.periodoUltimoAtendimento ?? null,
      grupoCondicao: !isEmpty(filter?.grupoCondicao) ? filter?.grupoCondicao : null,
      problemasCondicoes: !isEmpty(filter?.problemasCondicoes) ? filter?.problemasCondicoes : null,
      ativoListaProblema: filter?.ativoListaProblema || null,
      sexo: !isEmpty(filter?.sexo) ? filter?.sexo : null,
      tipoFaixaEtaria: filter?.tipoFaixaEtaria ?? null,
      faixaEtariaRange: filter?.faixaEtariaRange ?? null,
      identidadeGenero: !isEmpty(filter?.identidadeGenero) ? filter?.identidadeGenero : null,
      ivcf: filter?.ivcf ?? undefined,
    },
    {
      periodoUltimoAtendimento: filterDefault?.periodoUltimoAtendimento,
      grupoCondicao: filterDefault?.grupoCondicao,
      problemasCondicoes: filterDefault?.problemasCondicoes,
      ativoListaProblema: filterDefault?.ativoListaProblema,
      sexo: filterDefault?.sexo,
      tipoFaixaEtaria: filterDefault?.tipoFaixaEtaria,
      faixaEtariaRange: filterDefault?.faixaEtariaRange,
      identidadeGenero: filterDefault?.identidadeGenero,
      ivcf: filterDefault?.ivcf,
    }
  )
}

export function getProcedimentosConsideradosTooltipText(
  procedimentos: string[],
  title?: { plural: string; singular: string }
): string {
  if (isEmpty(procedimentos)) return ''

  const { plural = 'Procedimentos considerados', singular = 'Procedimento considerado' } = title ?? {}
  const actualTitle = procedimentos.length > 1 ? plural : singular

  return `${actualTitle}:\n${procedimentos.join('\n\n')}`
}
